export default __webpack_public_path__ + "static/media/clem-onojeghuo.862a0952.jpg";